import React from 'react';

type MemoryProps = {
  width?: string | number;
  height?: string | number;
  fill?: string;
  stroke?: string;
};

function MemoryBulbIcon({
  width = 50,
  height = 50,
  fill = 'none',
  stroke = 'white',
}: MemoryProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.12602 2.41782C2.78142 6.64718 5.4456 12.6915 7.64314 14.1734C8.58859 14.9594 9.0031 16.5434 9.09218 17.2372V19.2686C9.15878 19.8281 9.48625 20.3232 9.64166 20.5008C9.7856 20.7095 10.1596 20.973 10.551 21.2088C11.1298 21.5575 11.7981 22.3184 12.4738 22.3144C13.432 22.3087 14.0939 21.5995 14.8405 20.9988C15.6 20.3876 15.8895 19.6573 15.9357 19.2686V17.5869C15.8292 15.7752 17.1124 14.3566 17.7673 13.8737C18.3268 13.3542 18.9884 12.314 19.2493 11.8589C21.1408 7.60958 19.0162 4.23833 17.7174 3.08386C13.881 -0.33958 9.72464 1.2134 8.12602 2.41782Z'
        stroke={stroke}
        strokeWidth='1.5'
      />
      <path
        d='M9.0752 17.7873L16.052 16.4219'
        stroke={stroke}
        strokeWidth='0.8'
      />
      <path
        d='M12.5066 4.3999L12.5066 4.70617L12.5066 12.9585'
        stroke={stroke}
        strokeWidth='0.8'
      />
      <path
        d='M9.09082 19.0196L15.9177 17.6875'
        stroke={stroke}
        strokeWidth='0.8'
      />
      <path
        d='M9.44165 20.2515L15.9022 18.9194'
        stroke={stroke}
        strokeWidth='0.8'
      />
      <path
        d='M8.57836 7.87894C8.44956 7.65306 8.37598 7.39162 8.37598 7.113C8.37598 6.25776 9.06928 5.56445 9.92452 5.56445C10.7063 5.56445 11.3528 6.14377 11.4581 6.89653'
        stroke={stroke}
        strokeWidth='0.8'
        strokeLinejoin='round'
      />
      <path
        d='M9.35836 10.56C8.50312 10.56 7.80981 9.86667 7.80981 9.01143C7.80981 8.1562 8.50312 7.46289 9.35836 7.46289'
        stroke={stroke}
        strokeWidth='0.8'
        strokeLinejoin='round'
      />
      <path
        d='M11.641 10.5764C11.641 11.4317 10.9477 12.125 10.0925 12.125C9.23725 12.125 8.54395 11.4317 8.54395 10.5764C8.54395 10.4914 8.5508 10.408 8.56398 10.3267'
        stroke={stroke}
        strokeWidth='0.8'
        strokeLinejoin='round'
      />
      <path
        d='M9.94043 11.7754C9.94043 12.6306 10.6337 13.3239 11.489 13.3239C11.8794 13.3239 12.2361 13.1794 12.5085 12.941'
        stroke={stroke}
        strokeWidth='0.8'
        strokeLinejoin='round'
      />
      <path
        d='M15.1033 11.7754C15.1033 12.6306 14.4099 13.3239 13.5547 13.3239C13.1643 13.3239 12.8075 13.1794 12.5352 12.941'
        stroke={stroke}
        strokeWidth='0.8'
        strokeLinejoin='round'
      />
      <path
        d='M13.4377 10.5765C13.4377 11.4318 14.1311 12.1251 14.9863 12.1251C15.8415 12.1251 16.5348 11.4318 16.5348 10.5765C16.5348 10.4991 16.5291 10.423 16.5182 10.3486'
        stroke={stroke}
        strokeWidth='0.8'
        strokeLinejoin='round'
      />
      <path
        d='M15.7197 10.56C16.575 10.56 17.2683 9.86667 17.2683 9.01143C17.2683 8.1562 16.575 7.46289 15.7197 7.46289'
        stroke={stroke}
        strokeWidth='0.8'
        strokeLinejoin='round'
      />
      <path
        d='M13.5703 7.01339C13.5703 6.15815 14.2636 5.46484 15.1189 5.46484C15.9741 5.46484 16.6674 6.15815 16.6674 7.01339C16.6674 7.25841 16.6105 7.49013 16.5092 7.69608'
        stroke={stroke}
        strokeWidth='0.8'
        strokeLinejoin='round'
      />
      <path
        d='M15.1041 5.71456C15.1041 4.85932 14.4108 4.16602 13.5556 4.16602C13.1509 4.16602 12.7825 4.32126 12.5066 4.57544'
        stroke={stroke}
        strokeWidth='0.8'
        strokeLinejoin='round'
      />
      <path
        d='M9.94043 5.71456C9.94043 4.85932 10.6337 4.16602 11.489 4.16602C11.906 4.16602 12.2845 4.33086 12.5629 4.59894'
        stroke={stroke}
        strokeWidth='0.8'
        strokeLinejoin='round'
      />
      <path
        d='M13.5039 9.69401C14.0189 9.69401 14.4364 9.27654 14.4364 8.76156C14.4364 8.24658 14.0189 7.8291 13.5039 7.8291'
        stroke={stroke}
        strokeWidth='0.8'
        strokeLinejoin='round'
      />
      <path
        d='M11.4736 9.69401C10.9587 9.69401 10.5412 9.27654 10.5412 8.76156C10.5412 8.24658 10.9587 7.8291 11.4736 7.8291'
        stroke={stroke}
        strokeWidth='0.8'
        strokeLinejoin='round'
      />
      <path
        d='M12.2115 14.6309C12.2115 14.4099 12.0324 14.2309 11.8115 14.2309C11.5906 14.2309 11.4115 14.4099 11.4115 14.6309L12.2115 14.6309ZM11.4115 14.6309L11.4115 17.1309L12.2115 17.1309L12.2115 14.6309L11.4115 14.6309Z'
        fill='white'
      />
      <path
        d='M13.5562 14.6309C13.5562 14.4099 13.3772 14.2309 13.1562 14.2309C12.9353 14.2309 12.7562 14.4099 12.7562 14.6309L13.5562 14.6309ZM12.7562 14.6309L12.7563 17.1309L13.5563 17.1309L13.5562 14.6309L12.7562 14.6309Z'
        fill='white'
      />
    </svg>
  );
}

export default MemoryBulbIcon;
